import React from 'react';
import Container from "../../Wrappers/Container";
import PayrollSummaryItem from "../../Molecules/Items/PayrollSummaryItem";
import CarouselGrid from "../../Wrappers/CarouselGrid";

const SummaryPayrollPanel = () => {

  return (
    <Container className="lg-cols-3">
      <h3>Resumen general</h3>
      <CarouselGrid
        breakpoints={{
          lg: 3,
          m: 3,
          s: 2,
        }}
      >
        <PayrollSummaryItem icon="user"
          title="Empleados liquidados"
          content="30"/>
        <PayrollSummaryItem icon="shield"
          title="Pago de seguridad social"
          content="23 de ago"/>
        <PayrollSummaryItem icon="document"
          title="Contratos por finalizar"
          content="7"/>


        <PayrollSummaryItem icon="document"
          title="Contratos por finalizar"
          content="7"/>
        <PayrollSummaryItem icon="document"
          title="Contratos por finalizar"
          content="7"/>
          <PayrollSummaryItem icon="document"
          title="Contratos por finalizar"
          content="7"/>


          <PayrollSummaryItem icon="document"
          title="Contratos por finalizar"
          content="7"/>
      </CarouselGrid>
    </Container>
  );
};

export default SummaryPayrollPanel;
